/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Description_TitleInputs */

const en_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Description`)
};

const fr_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description audio`)
};

const de_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibung`)
};

const it_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione audio`)
};

const ru_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиоописание`)
};

const es_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de audio`)
};

const zh_cn2_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述`)
};

const ja_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明`)
};

const hi_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण`)
};

const pt_pt2_file_export_audio_description_title = /** @type {(inputs: File_Export_Audio_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição em áudio`)
};

/**
* | output |
* | --- |
* | "Audio Description" |
*
* @param {File_Export_Audio_Description_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_description_title = /** @type {((inputs?: File_Export_Audio_Description_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Description_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_audio_description_title(inputs)
	if (locale === "de") return de_file_export_audio_description_title(inputs)
	if (locale === "it") return it_file_export_audio_description_title(inputs)
	if (locale === "ru") return ru_file_export_audio_description_title(inputs)
	if (locale === "es") return es_file_export_audio_description_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_audio_description_title(inputs)
	if (locale === "ja") return ja_file_export_audio_description_title(inputs)
	if (locale === "hi") return hi_file_export_audio_description_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_audio_description_title(inputs)
	return en_file_export_audio_description_title(inputs)
});